import { useCallback, useState } from 'react'
import { DropDownItem } from 'types/components'

export const useVoucherMembersSelectQuery = () => {
  const [selectedMembers, selectedMembersSet] = useState<DropDownItem[]>([])

  const onSelectMembers = useCallback((member: DropDownItem) => {
    if (!member) return
    selectedMembersSet(prev =>
      prev.some(item => item.value === member.value)
        ? prev.filter(item => item.value !== member.value)
        : [...prev, member]
    )
  }, [])

  return {
    selectedMembers,
    onSelectMembers,
  }
}

export const useVoucherMerchantsSelectQuery = () => {
  const [selectedMerchants, selectedMerchantsSet] = useState<DropDownItem[]>([])

  const onSelectMerchants = useCallback((merchant: DropDownItem) => {
    if (!merchant) return
    selectedMerchantsSet(prev =>
      prev.some(item => item.value === merchant.value)
        ? prev.filter(item => item.value !== merchant.value)
        : [...prev, merchant]
    )
  }, [])

  return {
    selectedMerchants,
    onSelectMerchants,
  }
}

export const useVoucherIssuerSelectQuery = () => {
  const [selectedIssuer, selectedIssuerSet] = useState<DropDownItem[]>([])

  const onSelectIssuer = useCallback((merchant: DropDownItem) => {
    if (!merchant) return
    selectedIssuerSet(prev =>
      prev.some(item => item.value === merchant.value)
        ? prev.filter(item => item.value !== merchant.value)
        : [...prev, merchant]
    )
  }, [])

  return {
    selectedIssuer,
    onSelectIssuer,
  }
}
